import React from 'react';

import ConfirmDeleteIcon from '../Buttons/ConfirmDeleteIcon';

type Props = {
  fields: any,
  index: number
};

const DeleteItem = (props: Props) => (
  <ConfirmDeleteIcon onClick={() => props.fields.remove(props.index)} />
);

export default DeleteItem;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/DeleteItem.tsx